export interface AvatarColor {
  id: string;
  name: string;
  value: string;
}

export const DEFAULT_AVATAR_COLORS: AvatarColor[] = [
  { id: 'grape', name: 'grape', value: '#62466B' },
  { id: 'purple', name: 'purple', value: '#976CA4' },
  { id: 'blue', name: 'blue', value: '#5793F3' },
  { id: 'navy', name: 'nay', value: '#3B5DB2' },
  { id: 'green', name: 'green', value: '#8D9C00' },
  { id: 'teal', name: 'teal', value: '#7ECBD2' },
  { id: 'pink', name: 'pink', value: '#CC7B9D' },
  { id: 'red', name: 'red', value: '#C05A5D' },
];
